import { memo } from 'react'
import Button from './Button'

function MicroButton({ variant = 'accent', ...props }) {
  return <Button size="micro" variant={variant === 'accent' ? 'main' : 'neutral'} {...props} />
}

export default memo(MicroButton)
